import { withHandlers } from 'recompose'
import { compose } from 'redux'

import * as notifications from '../actions/notifications'
import { fsCollections } from './firestore'

export const deleteTournamentHelper = compose<any>(
  withHandlers({
    deleteSuccess: ({ dispatch }) => () => {
      dispatch(notifications.notifySuccess('Tournament has been deleted.'))
    },
    deleteError: ({ dispatch }) => err => {
      // tslint:disable-next-line:no-console
      console.error('Failed to delete tournamnent', err)
      dispatch(notifications.notifyFailure('Failed to delete tournament.'))
    },
    deleteTournament: ({ firestore, tenant }) => tournamentId => {
      return firestore.delete({
        collection: fsCollections.tournaments(tenant),
        doc: tournamentId,
      })
    },
  }),
  withHandlers({
    removeTournament: ({ deleteTournament, deleteSuccess, deleteError }) => tournamentId => () =>
      deleteTournament(tournamentId)
        .then(() => deleteSuccess())
        .catch(err => deleteError(err)),
  }),
)



// WEBPACK FOOTER //
// ./src/helpers/delete-tournament.ts